module.exports = __webpack_public_path__ + "img/smart-phone.c21fc534.svg";